"use client";

import { parseComment } from "./dangerActions";
import { useDangerActions } from "./useDangerActions";

/**
 * Рендер строки comment: обычный текст + инлайновые чипы danger-действий.
 * Чип = токен [TAG:key]; подпись резолвится из перечисления (fallback — key).
 */
export function CommentText({ value }: { value: string }) {
  const { labelOf } = useDangerActions();
  const segments = parseComment(value);

  return (
    <p className="text-sm text-foreground leading-snug">
      {segments.map((seg, i) =>
        seg.type === "text" ? (
          <span key={i} style={{ whiteSpace: "pre-wrap" }}>
            {seg.value}
          </span>
        ) : (
          <span
            key={i}
            className="mx-0.5 inline-flex items-center rounded-md border border-[#E0E3F5] bg-[#F1F3FF] px-1.5 py-0.5 text-xs font-medium text-[#3730A3] align-baseline"
          >
            {labelOf(seg.key)}
          </span>
        ),
      )}
    </p>
  );
}
